<template>
  <section class="end-ticket">
    <div class="text">
      QRコードを<br />
      再取得する
    </div>
    <div class="button-reload">
      <button @click="onTapReload">
        <img src="@/assets/img/icon/svg/icon-reload.svg" />
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "FaceQRReloadSection",
  props: {
    onTapReload: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style scoped>
.end-ticket {
  width: calc(35vw - 30px);
  padding: 60px 15px;
  text-align: center;
}
.end-ticket .text {
  font-size: 14px;
  line-height: 18px;
  font-weight: bold;
  text-align: center;
}
.end-ticket .button-reload {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 15px;
}
.end-ticket .button-reload button {
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 25px;
  background-color: #ffda5f;
  box-shadow: var(--defaultBoxShadow);
}
.end-ticket .button-reload button img {
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 2px 0 0;
  border-radius: none;
  box-shadow: none;
}
</style>
